export const UUIDLOCALSTORAGE = "823f8f69-29e6-4111-9543-4662f32baf0b";
